import { PaymentMethodIdEnum } from "@core/types";
import { IonSegment, IonSegmentButton, IonIcon, useIonViewWillEnter } from "@ionic/react";
import { t } from "i18next";
import { cashOutline, cardOutline } from "ionicons/icons";
import React, { useState } from "react";
import { Control, Controller } from "react-hook-form";
import { CartFormValues } from "./types";
import classNames from "classnames/bind";
import styles from "./CartForm.module.scss";
import { useOrderData } from "../../../providers/orderDataStore";

interface PaymentTabsProps {
  control: Control<CartFormValues>;
  shakePayment: boolean;
}

const cx = classNames.bind(styles);

export const PaymentTabs = ({ control, shakePayment }: PaymentTabsProps) => {
  const { updateOrderData, paymentMethod } = useOrderData();

  const handlePaymentMethodSelect = (method: PaymentMethodIdEnum) => {
    updateOrderData({
      paymentMethod: {
        id: method === PaymentMethodIdEnum.cash ? "1" : "2",
        title: method === PaymentMethodIdEnum.cash ? "Наличными" : "Безналичная оплата",
        type: method,
      },
    });
  };

  useIonViewWillEnter(() => {
    if (!paymentMethod) {
      updateOrderData({
        paymentMethod: {
          id: "1",
          title: "Наличными",
          type: PaymentMethodIdEnum.cash,
        },
      });
    }
  }, [paymentMethod, updateOrderData]);

  return (
    <Controller
      name="payment"
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <div
            className={cx("flex items-center justify-between px-2.5 py-4 border-y-1 min-h-[4.625rem]", {
              shake: shakePayment,
            })}
          >
            <div className="flex flex-col ">
              <div className="flex items-center gap-1 text-[#292929]">
                <span>{t("Payment")}</span>
                <span className="text-xs text-red-500">*</span>
              </div>
              <div className="text-xs text-[#656565]">{value}</div>
            </div>

            <IonSegment
              color="dark"
              className={cx("paymentSegment", "w-36")}
              value={value}
              defaultValue={PaymentMethodIdEnum.cash}
              onIonChange={(e) => {
                const selectedValue = e.detail.value;
                if (selectedValue === "Наличными") {
                  onChange("Наличными");
                  handlePaymentMethodSelect(PaymentMethodIdEnum.cash);
                } else if (selectedValue === "Безналичная оплата") {
                  onChange("Безналичная оплата");
                  handlePaymentMethodSelect(PaymentMethodIdEnum.card);
                }
              }}
            >
              <IonSegmentButton value="Наличными" color="success">
                <IonIcon icon={cashOutline} />
              </IonSegmentButton>
              <IonSegmentButton value="Безналичная оплата">
                <IonIcon icon={cardOutline} />
              </IonSegmentButton>
            </IonSegment>
          </div>
        );
      }}
    />
  );
};
